import { useState, useLayoutEffect, RefObject } from 'react'

const useElementWidth = <T extends Element>(ref: RefObject<T>) => {
  const [width, setWidth] = useState(0)

  useLayoutEffect(() => {
    const element = ref.current
    if (!element) {
      return
    }

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          if (entry.contentRect) {
            setWidth(entry.contentRect.width)
          }
        }
      })

      resizeObserver.observe(element)
      return () => resizeObserver.unobserve(element)
    }

    const handleResize = () => setWidth(element.clientWidth)
    handleResize()

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [ref])

  return width
}

export default useElementWidth
try {
    // @ts-ignore
    useElementWidth.displayName = "useElementWidth";
    // @ts-ignore
    useElementWidth.__docgenInfo = { "description": "", "displayName": "useElementWidth", "props": { "current": { "defaultValue": null, "description": "", "name": "current", "required": true, "type": { "name": "T" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/hooks/useElementWidth.ts#useElementWidth"] = { docgenInfo: useElementWidth.__docgenInfo, name: "useElementWidth", path: "src/hooks/useElementWidth.ts#useElementWidth" };
}
catch (__react_docgen_typescript_loader_error) { }